export class BaseModel {
  id: string;
  creationDate: string;
  updateDate: string;
}
